import { template as template_391d553708ea4677bbc544558ac0bc80 } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { WithBoundArgs } from '@glint/template';
import velvetAutoAnimate from '../modifiers/velvet-auto-animate.ts';
import VelvetButton from './velvet-button.gts';
import VelvetIconButton from './velvet-icon-button.gts';
export interface VelvetDisclosureSignature {
    Args: {
        /// Indicate if the disclosed content should animate.
        /// @default [true]
        shouldAnimate?: boolean;
    };
    Blocks: {
        /// The content of the disclosure.
        content: [publicAPI: PublicAPI];
        /// The trigger of the disclosure.
        trigger: [publicAPI: PublicAPI & {
                Button: WithBoundArgs<typeof VelvetButton, 'isDisclosure' | 'isExpanded' | 'onClick'>;
                IconButton: WithBoundArgs<typeof VelvetIconButton, 'onClick'>;
            }];
    };
    Element: HTMLDivElement;
}
interface PublicAPI {
    hide: () => void;
    isShown: boolean;
    show: () => void;
    toggle: () => void;
}
export default class VelvetDisclosure extends Component<VelvetDisclosureSignature> {
    @tracked
    isShown = false;
    get shouldAnimate() {
        return typeof this.args.shouldAnimate === 'boolean' ? this.args.shouldAnimate : true;
    }
    hide = ()=>{
        this.isShown = false;
    };
    show = ()=>{
        this.isShown = true;
    };
    toggle = ()=>{
        if (this.isShown) {
            this.hide();
        } else {
            this.show();
        }
    };
    static{
        template_391d553708ea4677bbc544558ac0bc80(`
    <div
      class="velvet-disclosure"
      {{(if this.shouldAnimate velvetAutoAnimate)}}
      ...attributes
    >
      {{yield
        (hash
          Button=(component
            VelvetButton
            isDisclosure=true
            isExpanded=this.isShown
            onClick=this.toggle
          )
          IconButton=(component
            VelvetIconButton
            isDisclosure=true
            isExpanded=this.isShown
            onClick=this.toggle
          )
          isShown=this.isShown
          hide=this.hide
          show=this.show
          toggle=this.toggle
        )
        to="trigger"
      }}

      {{#if this.isShown}}
        {{yield
          (hash
            isShown=this.isShown hide=this.hide show=this.show toggle=this.toggle
          )
          to="content"
        }}
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3ZlbHZldC10aHVuZGVyL3ZlbHZldC10aHVuZGVyL3ZlbHZldC10aHVuZGVyL3NyYy9jb21wb25lbnRzL3ZlbHZldC1kaXNjbG9zdXJlLmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBoYXNoIH0gZnJvbSAnQGVtYmVyL2hlbHBlcic7XG5pbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5pbXBvcnQgeyB0cmFja2VkIH0gZnJvbSAnQGdsaW1tZXIvdHJhY2tpbmcnO1xuaW1wb3J0IHR5cGUgeyBXaXRoQm91bmRBcmdzIH0gZnJvbSAnQGdsaW50L3RlbXBsYXRlJztcbmltcG9ydCB2ZWx2ZXRBdXRvQW5pbWF0ZSBmcm9tICcuLi9tb2RpZmllcnMvdmVsdmV0LWF1dG8tYW5pbWF0ZS50cyc7XG5pbXBvcnQgVmVsdmV0QnV0dG9uIGZyb20gJy4vdmVsdmV0LWJ1dHRvbi5ndHMnO1xuaW1wb3J0IFZlbHZldEljb25CdXR0b24gZnJvbSAnLi92ZWx2ZXQtaWNvbi1idXR0b24uZ3RzJztcblxuZXhwb3J0IGludGVyZmFjZSBWZWx2ZXREaXNjbG9zdXJlU2lnbmF0dXJlIHtcbiAgQXJnczoge1xuICAgIC8vLyBJbmRpY2F0ZSBpZiB0aGUgZGlzY2xvc2VkIGNvbnRlbnQgc2hvdWxkIGFuaW1hdGUuXG4gICAgLy8vIEBkZWZhdWx0IFt0cnVlXVxuICAgIHNob3VsZEFuaW1hdGU_OiBib29sZWFuO1xuICB9O1xuICBCbG9ja3M6IHtcbiAgICAvLy8gVGhlIGNvbnRlbnQgb2YgdGhlIGRpc2Nsb3N1cmUuXG4gICAgY29udGVudDogW3B1YmxpY0FQSTogUHVibGljQVBJXTtcblxuICAgIC8vLyBUaGUgdHJpZ2dlciBvZiB0aGUgZGlzY2xvc3VyZS5cbiAgICB0cmlnZ2VyOiBbXG4gICAgICBwdWJsaWNBUEk6IFB1YmxpY0FQSSAmIHtcbiAgICAgICAgQnV0dG9uOiBXaXRoQm91bmRBcmdzPFxuICAgICAgICAgIHR5cGVvZiBWZWx2ZXRCdXR0b24sXG4gICAgICAgICAgJ2lzRGlzY2xvc3VyZScgfCAnaXNFeHBhbmRlZCcgfCAnb25DbGljaydcbiAgICAgICAgPjtcbiAgICAgICAgSWNvbkJ1dHRvbjogV2l0aEJvdW5kQXJnczx0eXBlb2YgVmVsdmV0SWNvbkJ1dHRvbiwgJ29uQ2xpY2snPjtcbiAgICAgIH0sXG4gICAgXTtcbiAgfTtcbiAgRWxlbWVudDogSFRNTERpdkVsZW1lbnQ7XG59XG5cbmludGVyZmFjZSBQdWJsaWNBUEkge1xuICBoaWRlOiAoKSA9PiB2b2lkO1xuICBpc1Nob3duOiBib29sZWFuO1xuICBzaG93OiAoKSA9PiB2b2lkO1xuICB0b2dnbGU6ICgpID0-IHZvaWQ7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFZlbHZldERpc2Nsb3N1cmUgZXh0ZW5kcyBDb21wb25lbnQ8VmVsdmV0RGlzY2xvc3VyZVNpZ25hdHVyZT4ge1xuICBAdHJhY2tlZCBpc1Nob3duID0gZmFsc2U7XG5cbiAgZ2V0IHNob3VsZEFuaW1hdGUoKSB7XG4gICAgcmV0dXJuIHR5cGVvZiB0aGlzLmFyZ3Muc2hvdWxkQW5pbWF0ZSA9PT0gJ2Jvb2xlYW4nXG4gICAgICA_IHRoaXMuYXJncy5zaG91bGRBbmltYXRlXG4gICAgICA6IHRydWU7XG4gIH1cblxuICBoaWRlID0gKCkgPT4ge1xuICAgIHRoaXMuaXNTaG93biA9IGZhbHNlO1xuICB9O1xuXG4gIHNob3cgPSAoKSA9PiB7XG4gICAgdGhpcy5pc1Nob3duID0gdHJ1ZTtcbiAgfTtcblxuICB0b2dnbGUgPSAoKSA9PiB7XG4gICAgaWYgKHRoaXMuaXNTaG93bikge1xuICAgICAgdGhpcy5oaWRlKCk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMuc2hvdygpO1xuICAgIH1cbiAgfTtcblxuICA8dGVtcGxhdGU-XG4gICAgPGRpdlxuICAgICAgY2xhc3M9XCJ2ZWx2ZXQtZGlzY2xvc3VyZVwiXG4gICAgICB7eyhpZiB0aGlzLnNob3VsZEFuaW1hdGUgdmVsdmV0QXV0b0FuaW1hdGUpfX1cbiAgICAgIC4uLmF0dHJpYnV0ZXNcbiAgICA-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